var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ingredients-wrapper"},_vm._l((_vm.ingredients),function(ingredient){return _c('CraftIngredient',{key:ingredient.item.id,attrs:{"data":ingredient}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }